(function () {
  'use strict';

  angular.module('app').component('invoiceStatusLabel', invoiceStatusLabel());

  function invoiceStatusLabel() {
    return {
      bindings: {
        status: '<',
        dueDate: '<',
      },
      controller: InvoiceStatusLabelComponent,
      controllerAs: 'vm',
      template:
        '<span class="status-label text-{{ vm.statusClass }}">' +
        '<i class="fa fa-circle"></i> {{ vm.statusTitle }}{{ vm.statusDays }}' +
        '</span>',
    };
  }

  InvoiceStatusLabelComponent.$inject = ['$translate', 'moment'];

  function InvoiceStatusLabelComponent($translate, moment) {
    const vm = this;

    vm.$onChanges = function () {
      setStatusLabel();
    };

    function setStatusLabel() {
      let statusClass = 'default';
      let statusIcon = '';
      let statusTitle = 'DRAFT';

      vm.statusDays = '';

      switch (vm.status) {
        // case 'draft':
        //   statusClass = 'default';
        //   statusTitle = 'DRAFT';
        //   break;
        case 'open':
          let dueDate = moment(vm.dueDate, 'YYYY-MM-DD').hours(0);
          let current = moment().startOf('day').hours(0);

          let days = moment.duration(dueDate.diff(current)).asDays();
          let preposition = '';

          if (days < 0) {
            statusClass = 'warning';
            statusTitle = 'OVERDUE';
            preposition = 'BY';
            days = days * -1;
          } else {
            preposition = '_IN';
            statusClass = 'primary';
            statusTitle = 'DUE';
          }

          vm.statusDays =
            ' ' + $translate.instant(preposition) + ' ' + days + ' ' + $translate.instant('DAYS');
          break;
        case 'paid':
          statusClass = 'success';
          statusTitle = 'PAID';
          break;
        case 'unpaid':
          statusClass = 'danger';
          statusTitle = 'UNPAID';
          break;
        case 'cancelled': // for no atv
          statusClass = 'default';
          statusTitle = 'CANCELLED';
          break;
        default:
          statusClass = 'default';
          statusTitle = 'DRAFT';
          break;
      }

      vm.statusClass = statusClass;
      vm.statusIcon = statusIcon;
      vm.statusTitle = $translate.instant(statusTitle);
    }
  }
})();
